import React, { useState } from 'react';
import { Snackbar } from '@mui/material';
import { ListaGenerica } from '../../shared';
import { ProductoListaItem, FiltrosProductosData } from '../types/producto.types';
import { Producto } from '../types';
import { configuracionProductos } from './configuracion/productosConfig';
import { useInactivarProducto } from '../hooks';
import { InactivarProductoModal } from '../components';

interface ProductoListProps {
  onNavigate?: (path: string) => void;
}

const filtrosIniciales: FiltrosProductosData = {
  busqueda: '',
  proveedor: '',
  color: '',
  activo: undefined,
  fechaDesde: undefined,
  fechaHasta: undefined,
  precioDesde: undefined,
  precioHasta: undefined,
};

const ordenamientoInicial = {
  campo: 'fechaCreacion' as keyof ProductoListaItem,
  direccion: 'desc' as const,
};

export const ProductoList: React.FC<ProductoListProps> = ({ onNavigate }) => {
  // Inactivar producto state
  const {
    modalOpen: inactivarModalOpen,
    selectedProducto: inactivarProducto,
    loading: inactivarLoading,
    error: inactivarError,
    openModal: openInactivarModal,
    closeModal: closeInactivarModal,
    inactivar: performInactivar,
  } = useInactivarProducto();

  // Toast state
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<'success' | 'error'>('success');

  const handleAccionProducto = async (accion: string, producto: ProductoListaItem) => {
    switch (accion) {
      case 'ver':
        console.log('Ver detalles del producto:', producto.id);
        // Aquí iría la lógica para ver detalles
        break;
      case 'editar':
        console.log('Editar producto:', producto.id);
        if (onNavigate) {
          onNavigate(`/productos/editar?id=${parseInt(producto.id)}`);
        }
        break;
      case 'duplicar':
        console.log('Duplicar producto:', producto.id);
        // Aquí iría la lógica para duplicar
        break;
      case 'eliminar':
        // Obtener datos completos del producto para el modal
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL || 'http://localhost:4000/api'}/productos/${producto.id}`
          );
          const data = await response.json();
          if (data.success && data.data) {
            openInactivarModal(data.data);
          } else {
            setToastMessage('No se pudo cargar el producto');
            setToastSeverity('error');
            setToastOpen(true);
          }
        } catch (error) {
          setToastMessage('Error al cargar el producto');
          setToastSeverity('error');
          setToastOpen(true);
        }
        break;
      default:
        break;
    }
  };

  const handleConfirmInactivar = async () => {
    if (!inactivarProducto) return;

    try {
      await performInactivar(inactivarProducto);
      setToastMessage('Producto desactivado correctamente');
      setToastSeverity('success');
      setToastOpen(true);
      // Recargar lista será manejado por ListaGenerica
      window.location.reload();
    } catch (err: any) {
      const errorMessage =
        err.message === 'El producto ya fue desactivado'
          ? 'El producto ya fue desactivado'
          : err.message || 'Error al inactivar producto';
      setToastMessage(errorMessage);
      setToastSeverity('error');
      setToastOpen(true);
    }
  };

  return (
    <>
      <ListaGenerica
        configuracion={configuracionProductos}
        filtrosIniciales={filtrosIniciales}
        ordenamientoInicial={ordenamientoInicial}
        onNavigate={onNavigate}
        onAccionItem={handleAccionProducto}
      />

      <InactivarProductoModal
        open={inactivarModalOpen}
        producto={inactivarProducto}
        loading={inactivarLoading}
        onConfirm={handleConfirmInactivar}
        onCancel={closeInactivarModal}
      />

      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        onClose={() => setToastOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        message={toastMessage}
      />
    </>
  );
}; 